import { render } from 'base/wrapped-render';
import { renderV2 } from 'base/wrapped-render-v2';
import { ifFeature } from '@bamboohr/utils/lib/feature';
import ApproverClockOut from './approver-clock-out.react';
import {noop} from 'lodash';
import './styles.styl';

export default function (data, callback, url = '/timesheet/clock/out/approval') {
	const title = data.length > 1 ? $.__('People are still clocked in') : $.__('%1$s is still clocked in', data[0].firstName);
	const onSuccess = typeof callback === 'function' ? callback : noop;

	const renderer = ifFeature(
		'REACT_18_TT_MIGRATION',
		() => renderV2({
			children: <ApproverClockOut afterAction={ onSuccess } employees={ data } title={ title } url={ url } />,
			attachedElement: document.createElement('div'),
		}),
		() => render(
			<ApproverClockOut afterAction={ onSuccess } employees={ data } title={ title } url={ url } />,
			document.createElement('div')
		)
	);
	renderer();
}
